import React, { useState, useEffect } from 'react';
import LeftDashboard from '../components/LeftDashboard';
import { fetchStats } from '../api';

export default function TimelinePage({ user, isEmbedded, view, setView, setSelectedCompany, refreshSignal, preloadedStats }) {
  const [stats, setStats] = useState(preloadedStats || null);
  const [loading, setLoading] = useState(!preloadedStats);

  useEffect(() => {
    if (preloadedStats) {
       setStats(preloadedStats);
       setLoading(false);
       return;
    }
    async function getStats() {
      try {
        const data = await fetchStats();
        setStats(data.stats);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }
    getStats();
  }, [refreshSignal, preloadedStats]);

  const content = (
    <main style={{ minWidth: 0, animation: 'fadeUp 0.4s ease-out' }}>

      <div style={{
        background: 'linear-gradient(135deg, var(--blue), var(--gold-light))',
        padding: '16px 24px', borderRadius: 12, color: '#fff',
        boxShadow: '0 8px 16px -4px rgba(14,165,233,0.3)',
        marginBottom: 12, position: 'relative', overflow: 'hidden'
      }}>
        <div style={{ position: 'absolute', right: -10, top: -20, fontSize: 80, opacity: 0.1 }}>⏳</div>
        <h1 style={{ fontFamily: 'var(--display)', fontSize: 28, fontWeight: 900, letterSpacing: -0.5, margin: '0 0 2px' }}>
          {loading ? '...' : (stats?.avgDaysToOffer || '14')} Days
        </h1>
        <h2 style={{ fontSize: 13, fontWeight: 600, opacity: 0.9, margin: 0, fontFamily: 'var(--sans)' }}>Median Interview Cycle</h2>
      </div>

      <div style={{ background: 'var(--surface)', padding: 12, borderRadius: 10, border: '1px solid var(--border)', marginBottom: 12 }}>
        <h3 style={{ fontSize: 13, margin: '0 0 12px', color: 'var(--text)' }}>Interview Speed & Efficiency</h3>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          <div style={{ background: 'var(--surface2)', padding: 12, borderRadius: 8 }}>
            <div style={{ fontSize: 10, color: 'var(--text3)', fontWeight: 600, textTransform: 'uppercase', marginBottom: 2 }}>Platform Goal</div>
            <div style={{ fontSize: 16, fontWeight: 800, color: 'var(--blue)' }}>&lt; 10 Days</div>
            <div style={{ fontSize: 11, color: 'var(--text2)', marginTop: 2 }}>Optimized process reduces anxiety</div>
          </div>

          <div style={{ background: 'var(--surface2)', padding: 12, borderRadius: 8 }}>
            <div style={{ fontSize: 10, color: 'var(--text3)', fontWeight: 600, textTransform: 'uppercase', marginBottom: 2 }}>Critical Alert</div>
            <div style={{ fontSize: 16, fontWeight: 800, color: 'var(--orange)' }}>21+ Days</div>
            <div style={{ fontSize: 11, color: 'var(--text2)', marginTop: 2 }}>High risk of candidate churn</div>
          </div>
        </div>

        <p style={{ fontSize: 12, color: 'var(--text3)', lineHeight: 1.4, marginTop: 12, marginInline: 0 }}>
          The interview cycle is a key indicator of company health. We track end-to-end timelines from first contact to verdict.
        </p>
      </div>

      <div style={{ padding: '20px', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 12, textAlign: 'center' }}>
        <div style={{ fontSize: 14, color: 'var(--text2)', fontWeight: 500 }}>
          Real-time speed benchmarks for individual companies are available on the <strong>Companies</strong> page.
        </div>
      </div>

    </main>
  );

  if (isEmbedded) return content;

  return (
    <div style={{
      maxWidth: 1100, margin: '0 auto', padding: '16px 24px',
      display: 'grid', gridTemplateColumns: '220px 1fr', gap: 28,
      alignItems: 'start'
    }}>
      <LeftDashboard user={user} view={view} setView={setView} setSelectedCompany={setSelectedCompany} />
      {content}
    </div>
  );
}
